export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/piaojumiaotie-0c8579513de769bd441760c322eacb98.jpeg";